import { Link } from "react-router-dom";
import type { AnnouncementSummary } from "../../../hooks/useAdminAnnouncements";
import { notArrivedCount, STATE_LABEL } from "../../../lib/announcements";
import { formatDateTime, formatDateTimeCompact } from "../../../utils/formatDateTime";
import shared from "../../../pages/AdminInstances.module.css";
import own from "./Announcements.module.css";

export const LIST_HEADERS = ["Created", "Message", "State", "Delivered", "Did not arrive", "By"];

type Props = { announcements: ReadonlyArray<AnnouncementSummary>; isFetching: boolean };

export const AnnouncementList = ({ announcements, isFetching }: Props): JSX.Element => (
  <table
    className={`${shared.table} ${own.compactTable}`}
    data-testid="announcement-list"
    data-fetching={isFetching ? "true" : "false"}
  >
    <thead>
      <tr>
        {LIST_HEADERS.map((header) => (
          <th key={header}>{header}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {announcements.map((item) => {
        const state = STATE_LABEL[item.state];
        const missed = notArrivedCount(item);
        return (
          <tr key={item.id} data-testid="announcement-row">
            <td className={shared.nowrap}>
              <Link className={own.link} to={item.id} title={formatDateTime(item.createdAt)}>
                {formatDateTimeCompact(item.createdAt)}
              </Link>
            </td>
            <td>
              <div className={own.excerpt}>{item.body}</div>
            </td>
            <td className={own[state.tone]}>{state.label}</td>
            <td>
              {item.counts.delivered ?? 0} / {item.total}
            </td>
            <td className={missed > 0 ? own.bad : undefined}>{missed}</td>
            <td className={shared.muted}>{item.sentBy ?? item.createdBy}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
);
